module.exports = __webpack_public_path__ + "media/luxury-2026/location-library-412d297e.jpg";